import { motion } from "framer-motion";
import { ShieldCheck, Award, Users, Target, TrendingUp } from "lucide-react";
import { VALUES } from "../../data/content";

const ICONS = [ShieldCheck, Award, Users, Target, TrendingUp];

export const Values = () => {
  return (
    <section
      id="valores"
      data-testid="values-section"
      className="relative py-24 border-t border-[#262626] bg-[#0F0F0F]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-12">
          <span className="font-body text-sm tracking-[0.25em] uppercase text-[#FF1616]">Lo que nos define</span>
          <h2 className="font-heading font-black uppercase text-white text-3xl sm:text-4xl tracking-tight mt-3">
            Nuestros valores
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#262626] border border-[#262626]">
          {VALUES.map((v, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="group bg-[#0A0A0A] hover:bg-[#141414] p-7 transition-colors"
                data-testid={`value-${v.title.toLowerCase()}`}
              >
                <Icon className="text-[#FF1616] mb-4 group-hover:scale-110 transition-transform" size={28} />
                <h3 className="font-heading font-bold uppercase text-white tracking-wide">{v.title}</h3>
                <p className="font-body text-sm text-neutral-400 mt-2 leading-relaxed">{v.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
